<div *ngIf="visible" class="w-100 d-flex flex-row justify-content-between align-items-center bg-kh-red-light px-kh-4 py-kh-3">
  <div class="align-self-start mr-kh-2 mt-kh-1">
    <kh-img path="danger.svg" class="icon"></kh-img>
  </div>
  <div class="content" class="kh-medium-text text-left">
    <ng-content></ng-content>
  </div>
  <div class="pointer" (click)="toggleVisibility()">
    <fa-icon [icon]="['fas','times']"></fa-icon>
  </div>
</div>